module.exports = __webpack_public_path__ + "img/20210619.f30a58f5.gif";